import React from "react";
import "../../css/Weather.css";
import { getClock } from "../../utils/WeatherUtils";

class Clock extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { date: new Date() };
  }

  componentDidMount() {
    this.timerID = setInterval(() => this.tick(), 1000);
  }

  componentWillUnmount() {
    clearInterval(this.timerID);
  }

  tick() {
    this.setState({
      time: new Date().toLocaleString()
    });
  }
  render() {
    return (
      <p className="App-clock">
        <i className={getClock()}></i> {this.state.time}
      </p>
    );
  }
}

export default Clock;
